/**
 * Sample data for Auto Fill in create quotation/invoice form (dev only).
 * Customer is not included – user must select from combobox.
 */
function toYyyyMmDd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export type DocumentCreateFormSample = {
  /** Document type code (from DB or sample: quotation, invoice, etc.) */
  documentType: string;
  documentNumber: string;
  issueDate: string;
  dueDate: string;
  referencePo: string;
  items: Array<{
    description: string;
    detail?: string;
    quantity: number;
    unit: string;
    unitPrice: number;
  }>;
  notes: string;
  paymentTerms: string;
  /** ISO 4217 — ສຳລັບຕົວຢ່າງ auto-fill */
  currency?: string;
  taxRate: number;
  discountAmount: number;
};

export const documentCreateFormSamples: DocumentCreateFormSample[] = [
  {
    documentType: "quotation",
    documentNumber: "QUO-2024-001",
    issueDate: toYyyyMmDd(new Date()),
    dueDate: toYyyyMmDd(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)),
    referencePo: "PO-2024-001",
    items: [
      {
        description: "ສິນຄ້າຕົວຢ່າງ A",
        detail: "ລາຍລະອຽດເພີ່ມເຕີມ (ຕົວຢ່າງ)",
        quantity: 10,
        unit: "ຊຸດ",
        unitPrice: 150,
      },
      { description: "ບໍລິການຕິດຕັ້ງ", quantity: 1, unit: "ຄັ້ງ", unitPrice: 500 },
    ],
    notes: "ລາຄານີ້ມີຄວາມຊັບຊ້ອນ 30 ວັນ",
    paymentTerms: "ຊຳລະພາຍໃນ 30 ວັນ. ການຊຳລະຊັກຊ້າຈະຖືກຄິດດ້ອງ 1.5% ຕໍ່ເດືອນ.",
    taxRate: 0.1,
    discountAmount: 0,
    currency: "LAK",
  },
  {
    documentType: "invoice",
    documentNumber: "INV-2024-001",
    issueDate: toYyyyMmDd(new Date()),
    dueDate: toYyyyMmDd(new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)),
    referencePo: "QUO-2024-001",
    items: [
      { description: "ອຸປະກອນອອບຟິດ", quantity: 2, unit: "ຊຸດ", unitPrice: 1200 },
      { description: "ເຄື່ອງໃຊ້ສຳອາງ", quantity: 5, unit: "ກ່ອງ", unitPrice: 85 },
    ],
    notes: "ອ້າງອີງຈາກລາຄາ QUO-2024-001",
    paymentTerms: "ຊຳລະພາຍໃນ 14 ວັນ. ການຊຳລະຊັກຊ້າຈະຖືກຄິດດ້ອງ 1.5% ຕໍ່ເດືອນ.",
    taxRate: 0.1,
    discountAmount: 50,
    currency: "THB",
  },
  {
    documentType: "quotation",
    documentNumber: "QUO-2024-002",
    issueDate: toYyyyMmDd(new Date()),
    dueDate: toYyyyMmDd(new Date(Date.now() + 45 * 24 * 60 * 60 * 1000)),
    referencePo: "",
    items: [
      {
        description: "ບໍລິການທຳຄວາມສະອາດປະຈຳເດືອນ",
        quantity: 1,
        unit: "ເດືອນ",
        unitPrice: 2500,
      },
      {
        description: "ວັດຖຸອຸປະກອນສຳອາງ",
        quantity: 12,
        unit: "ຊຸດ",
        unitPrice: 120,
      },
    ],
    notes: "ລາຄາສຳລັບສັນຍາບໍລິການ 12 ເດືອນ",
    paymentTerms: "ຊຳລະລາຍເດືອນ. ການຊຳລະຊັກຊ້າຈະຖືກຄິດດ້ອງ 1.5% ຕໍ່ເດືອນ.",
    taxRate: 0.1,
    discountAmount: 100,
    currency: "USD",
  },
  {
    documentType: "invoice",
    documentNumber: "INV-2024-002",
    issueDate: toYyyyMmDd(new Date()),
    dueDate: toYyyyMmDd(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)),
    referencePo: "PO-2024-102",
    items: [
      {
        description: "ເຄື່ອງຈັກກະສານ",
        quantity: 3,
        unit: "ເຄື່ອງ",
        unitPrice: 3500,
      },
      { description: "ອະນຸບຳສຳຮອງ", quantity: 6, unit: "ຊຸດ", unitPrice: 180 },
    ],
    notes: "ສົ່ງມອບພາຍໃນ 7 ວັນຫຼັງຊຳລະ",
    paymentTerms: "ຊຳລະພາຍໃນ 7 ວັນ. ຊຳລະກ່ອນຮັບສິນຄ້າ.",
    taxRate: 0,
    discountAmount: 200,
    currency: "USD",
  },
  {
    documentType: "quotation",
    documentNumber: "QUO-2024-003",
    issueDate: toYyyyMmDd(new Date()),
    dueDate: toYyyyMmDd(new Date(Date.now() + 60 * 24 * 60 * 60 * 1000)),
    referencePo: "RFQ-2024-05",
    items: [
      {
        description: "ຊຸດບໍລິການດູແລລະບົບ IT",
        quantity: 1,
        unit: "ປີ",
        unitPrice: 12000,
      },
      {
        description: "ຕິດຕັ້ງແລະຝຶກອົບຮົມ",
        quantity: 1,
        unit: "ຄັ້ງ",
        unitPrice: 2500,
      },
    ],
    notes: "ລາຄາປີແຮກສຳລັບບໍລິສັດຂະໜາດກາງ",
    paymentTerms: "ຊຳລະລາຍເດືອນ ຫຼື ຊຳລະທັງໝົດລ່ວງໜ້າໄດ້ສ່ວນຫຼຸດ 5%.",
    taxRate: 0.1,
    discountAmount: 0,
    currency: "LAK",
  },
];
